export default __webpack_public_path__ + "static/media/dotnet.77604eed.png";